import Vue from 'vue'
import router from '@/router'
import { saveStorage } from "@/services/serviceLocalStorage";
import suscripcionesApi from '@/api/suscripciones';

export async function signIn(context, user) {
    try {
        console.log("Iniciando sesión con usuario:", user);
        
        // 1. Activar la animación de carga
        context.commit('initialData/SET_LOADING_DATA_INIT', true, { root: true });
        console.log("Activando loading de animación por 15 segundos...");


        // 2. Realizar la llamada asincrónica para iniciar sesión
        const response = await context.dispatch('login', user);
        console.log("signIn - Respuesta del inicio de sesión:", response);

        // 3. Cargar los datos iniciales
        const data_init = await context.dispatch('initialData/fetchInitConfig', {}, { root: true });
        console.log("signIn - Datos iniciales cargados:", data_init);

        // 4. Cargar módulos de suscripción
        await context.dispatch('fetchMisModulos');

        // Limpiar errores y redirigir
        context.commit('cleanError', '', { root: true });
        
        // Es importante desactivar el loading antes o justo después de la redirección
        // dependiendo de si el Layout de destino también escucha esta variable
        // context.commit('initialData/SET_LOADING_DATA_INIT', false, { root: true });

        const role = context.state.user.role || [];
        if (role.includes('produccion')) {
          router.push({ name: 'empresa.produccion.cola' });
        } else {
          router.push('/');
        }

        return response.data;

    } catch (error) {
        console.error("Error en signIn:", error);
        // En caso de error, siempre desactivamos el loading para no bloquear al usuario
        context.commit('initialData/SET_LOADING_DATA_INIT', false, { root: true });
        
        // Aquí podrías disparar una mutación para mostrar el error en el Login
        context.commit('setError', error.message || "Error al iniciar sesión", { root: true });
    } 
}

export async function login(context, user){
    try {
        const response = await Vue.axios({
            method: 'POST',
            url: '/usuarios/token',
            data: user
        });
    
        // Almacenar tokens de acceso y actualización en el almacenamiento local
        localStorage.setItem('token_access', response.data.access);
        localStorage.setItem('token_refresh', response.data.refresh);
        console.log("user", response.data.response.user);
        
        context.commit('SET_ISLOGGED', true);
        context.commit('SET_USERNAME', response.data.response.user.username);
        context.commit('SET_FULLNAME', response.data.response.user.full_name);
        context.commit('SET_ROLES', response.data.response.user.roles);
        
        context.commit('SET_GROUP', response.data.response.user.groups);
    
        context.commit('SET_EMPRESA', response.data.response.empresa);
        return response
    } catch (error) {
        console.log('error', error);

        // Manejar errores durante el inicio de sesión
        context.commit('authError');

        if (error.response && error.response.status) {
            const status = error.response.status;

            // Manejar errores específicos según el código de estado de la respuesta
            switch (status) {
                case 480:
                case 400:
                    context.commit('setError', error.response.data.detail, { root: true });
                    break;
                default:
                    context.commit('setError', "Usuario o contraseña incorrectos.", { root: true });
                    break;
            }
        } else {
            // Manejar otros tipos de errores (por ejemplo, errores de red)
            context.commit('setError', "Error de red u otra situación inesperada.", { root: true });
        }
        throw error;
    }
    

}
export function registrar_usuario({ commit, dispatch }, user) {
    return new Promise((resolve, reject) => {
        Vue.axios({
            method: 'POST',
            url: '/usuarios/usuarios',
            data: user
        }).then(response => {
            resolve(response);
        }).catch(e => {
            reject(e);
        })
    })

}


export async function logOut(context, msg) {
    context.commit('setLoadingInit', true, { root: true }) //root true, se define la mutacion en la mutacion root

    // La sesión se borra del navegador aunque el back no responda: si los
    // tokens quedaran guardados, la PC seguiría entrada con este usuario y el
    // turno siguiente operaría a su nombre (Venecia, 22/10/2026).
    const refresh = localStorage.getItem('token_refresh')
    localStorage.removeItem('token_access')
    localStorage.removeItem('token_refresh')
    localStorage.removeItem('vuex')

    try {
        // El back invalida el refresh para que no pueda renovar la sesión.
        await Vue.axios.post('/usuarios/logout', { refresh })
    } catch (error) {
        console.log(error);
    }

    if (msg) {
        context.commit('setError', msg, { root: true })
    } else {
        context.commit('cleanError', '', { root: true })
    }
    context.commit('REMOVE_USER');
    context.commit('SET_ISLOGGED', false);
    context.commit('SET_USERNAME', '');
    context.commit('SET_FULLNAME', null);
    context.commit('SET_ROLES', []);
    context.commit('SET_GROUP', null);
    context.commit('SET_SUSCRIPCION', { plan: null, vigente: false, modulos: [], features: [] });
    context.commit('initialData/SET_LOADING_DATA_INIT', false, { root: true });
    context.commit('setLoadingInit', false, { root: true })

    if (router.currentRoute.name !== 'login') {
        router.push({ name: 'login' })
    }
}


export async function fetchMisModulos(context) {
    try {
        const response = await suscripcionesApi.getMisModulos()
        context.commit('SET_SUSCRIPCION', response.data)
    } catch (e) {
        // Si falla (empresa sin suscripción), dejamos el estado vacío
        context.commit('SET_SUSCRIPCION', { plan: null, vigente: false, modulos: [], features: [] })
    }
}

export async function get_user_group(context) {

    var url = "/usuarios/group";


    const user = await Vue.axios({
        method: 'GET',
        url: url
    })
    context.commit('setUserGroup', user.data)


}